import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { EMPTY, Observable, ReplaySubject, throwError } from 'rxjs';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { AcessoService } from '../services/acesso.service';
import { LoadingController } from '@ionic/angular';
import { environment } from 'src/environments/environment';
import { AuthService } from '../services/auth.service';
import { switchMap, finalize, catchError, take } from 'rxjs/operators';

//TODO: Pode ser melhorado, (usar services para verrificar se o token está sendo atualizado)
@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    tokenExpDate = localStorage.getItem('tokenExpDate') || '0';
    isRefreshing = false;
    subjectRefreshToken: ReplaySubject<void> = new ReplaySubject<void>(1);

    constructor(
        private acessoService: AcessoService,
        private router: Router,
        private loadingController: LoadingController,
        private authService: AuthService,
    ) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // console.log(request.url)

        if (request.url.includes('/login')) {
            request = this.injectToken(request);
            return this.validateResponse(request, next);
        }
        if (request.url.includes('/logout')) {
            request = this.injectToken(request);
            return this.validateResponse(request, next);
        }
        if (request.url.includes('/logout-sso')) {
            request = this.injectToken(request);
            return this.validateResponse(request, next);
        }
        if (request.url.includes('/revoke-token')) {
            request = this.injectToken(request);
            return next.handle(request);
        }
        if (request.url.includes('/refreshToken')) {
            // console.log('dentro do refresh')

            if (this.isRefreshing) {
                return EMPTY;
            }
            this.isRefreshing = true;
            request = this.injectToken(request);
            return this.validateResponse(request, next).pipe(
                finalize(() => {
                    setTimeout(() => {
                        this.subjectRefreshToken.next();
                        this.isRefreshing = false;
                    }, 300);
                }),
                catchError((err) => {
                    console.warn('[AuthInterceptor] Erro no refresh de token', err);
                    return throwError(err);
                })
            );
        }



        const path = this.router.routerState.snapshot.url;
        if (!path.includes('/login')) {
            this.tokenValido().then(async (isValido) => {
                if (!isValido) {
                    await this.exit();
                } else {
                    await this.verifyInterval();
                }
            });
        } else {
            this.tokenValido().then(async (isValido) => {
                if (!isValido) {
                    this.clearStorage();
                }
            });
        }

        request = this.injectToken(request);

        if (this.isRefreshing) {
            return this.subjectRefreshToken.asObservable().pipe(
                take(1),
                switchMap(() => {
                    request = this.injectToken(request);
                    console.log(request.url);
                    return this.validateResponse(request, next);
                })
            );
        }
        return this.validateResponse(request, next);
    }

    private validateResponse(request: HttpRequest<any>, next: HttpHandler) {
        return next.handle(request).pipe(
            catchError(async (err) => {
                console.warn('[AuthInterceptor] Erro na requisição', err);
                const contentType = err.headers.get('Content-Type');
                console.log(err.headers);
                if (contentType?.split(';')[0] === 'text/html') {
                    await this.exit();
                    throw(err);
                }
                throw(err);
            })
        );

    }

    private async exit() {
        const path = this.router.routerState.snapshot.url;
        if (!path.includes('/login')) {

            try {
                await this.acessoService.revoke();
            } catch (err) {
                console.warn('[AuthInterceptor] Erro ao revogar token; seguindo fluxo', err);
            }
            this.clearStorage();
            this.openLogoutIframe();
            this.acessoService.logout();
            this.router.navigate(['/login']);
            await this.clearLoading();
        }
    }

    private openLogoutIframe() {
        const windowFeatures = 'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=1,height=1,left=100,top=100';
        const handle = window.open(`${environment.backendUrl}/logout`, 'mozillaWindow', windowFeatures);
        setTimeout(() => {
            handle.close();
        }, 300);
    }

    private async clearLoading() {
        let loading = await this.loadingController.getTop();
        if (!loading) {
            return;
        }
        loading.dismiss();
        setTimeout(async () => {
            this.clearLoading()
        }, 300);
    }


    async tokenValido() {
        this.tokenExpDate = localStorage.getItem('tokenExpDate') || '0';
        const today = moment().unix();
        if (today >= parseInt(this.tokenExpDate)) {
            return false;
        }
        return true;
    }

    async verifyInterval() {
        this.tokenExpDate = localStorage.getItem('tokenExpDate') || '0';
        const today = moment().unix();

        const intervalSeconds = parseInt(this.tokenExpDate) - today;
        const minute = 5;
        // console.log(intervalSeconds);
        if (intervalSeconds > 0 && intervalSeconds < minute * 60) {
        await this.authService.refreshToken().then((res) => {
            if (res) {
                localStorage.setItem('token', res);
                this.tokenExpDate = this.authService.decodePayloadJWT(res).exp;
                localStorage.setItem('tokenExpDate', this.tokenExpDate);
            }
        }).catch(err => {
            console.trace(err);
            // Garanta que requisições aguardando sejam liberadas mesmo em erro
            this.isRefreshing = false;
            this.subjectRefreshToken.next();
        });
        }


    }

    clearStorage() {
        localStorage.removeItem('token');
        localStorage.removeItem('userLogged');
        localStorage.removeItem('formContatoAssitencial');
        localStorage.removeItem('formContatoProcedimento');
        localStorage.removeItem('formProblemaDiagnostico');
        localStorage.removeItem('formProcedimento');
        localStorage.removeItem('formProfProcedimento');
    }

    injectToken(request: HttpRequest<any>) {
        if (this.token) {
            request = request.clone(
                {
                    // withCredentials: true,
                    setHeaders: {
                        Authorization: `Bearer ${this.token}`
                    }
                });
        }
        return request;
    }


    get token() {
       return localStorage.getItem('token') || '';
    }
}